<template>
  <v-tooltip bottom>
    <v-btn
      slot="activator"
      class="confirmed-order-button"
      :loading="loading"
      disabled
      round
    >
      <span>{{ confirmedOrderPrice.toFixed(2) }} &euro;</span>
    </v-btn>
    <span v-t="'mainComponent.orderAmount'" />
  </v-tooltip>
</template>

<script>
export default {
  name: 'ConfirmedOrderButton',
  props: {
    confirmedOrderPrice: {
      type: Number,
      default: 0,
    },
    loading: {
      type: Boolean,
    },
  },
};
</script>

<style scoped>
  .confirmed-order-button {
    min-width: 60px;
    margin-left: 4px;
    margin-right: 0;
  }
</style>
